import { PILL_COLORS } from "components/ui/Pill";

/**
 * Returns pill color config for gender.
 * @param {string} gender
 * @returns {Object}
 */
export const getGenderPillColors = (gender) => {
  if (!gender) return PILL_COLORS.genderUnknown;
  const upper = String(gender).toUpperCase();
  if (upper === "MALE") return PILL_COLORS.genderMale;
  if (upper === "FEMALE") return PILL_COLORS.genderFemale;
  return PILL_COLORS.genderUnknown;
};

/**
 * Formats gender string to Title Case.
 * @param {string} gender
 * @returns {string}
 */
export const formatGenderText = (gender) => {
  if (!gender) return "Unknown";
  const upper = String(gender).toUpperCase();
  if (upper === "MALE") return "Male";
  if (upper === "FEMALE") return "Female";
  return (
    String(gender).charAt(0).toUpperCase() +
    String(gender).slice(1).toLowerCase()
  );
};
